import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { ProfileContext } from '@loyalup/core';
import Layout from 'components/Layout';
import GlobalError from 'components/GlobalError';
import { NotificationCenter, NotificationsProvider } from 'components/Notifications';
import Topbar from 'components/Topbar';
import Sidebar from 'components/Sidebar';

import s from './CabinetLayout.module.css';

const FullScreenContext = React.createContext();

const FullscreenLayoutProvider = ({ children }) => {
  const [fullScreen, setFullScreen] = useState(false);

  return <FullScreenContext.Provider value={[fullScreen, setFullScreen]}>{children}</FullScreenContext.Provider>;
};

const useFullScreenLayout = () => useContext(FullScreenContext);

const InnerLayout = ({ children, sidebarMenu, ...props }) => {
  const profile = useContext(ProfileContext);
  const [isFullscreen] = useFullScreenLayout();

  return (
    <Layout>
      {!profile && <GlobalError type="connection" />}
      {profile && (
        <NotificationsProvider>
          <NotificationCenter />
          {isFullscreen ? (
            children
          ) : (
            <>
              <Topbar />
              <Sidebar {...props}>{sidebarMenu}</Sidebar>
              <div className={s.container}>{children}</div>
            </>
          )}
        </NotificationsProvider>
      )}
    </Layout>
  );
};

const CabinetLayout = props => (
  <FullscreenLayoutProvider>
    <InnerLayout {...props} />
  </FullscreenLayoutProvider>
);

CabinetLayout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebarMenu: PropTypes.node.isRequired,
  env: PropTypes.string.isRequired,
};

CabinetLayout.useFullScreenLayout = useFullScreenLayout;

export default CabinetLayout;
